import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import thankYouIcon from "assets/images/icons/thankYouIcon@svg.svg";
import * as general from "store/entities/general/action";

class GetStartedSuccess extends Component {
    state = { 
        pageAccess: "",
    }

    componentDidMount() {
        let pageAccess = "";
        if ("payload" in this.props.match.params){
            const {payload} = this.props.match.params;

            if (payload !== "") {
                pageAccess = true;
                // console.log(payload);
                const setWithdrawalLimitParams = {
                    code: payload,
                }
                this.props.setWithdrawalLimit(setWithdrawalLimitParams);
            }
            else{
                pageAccess = false;
            }

        }
        else{
            pageAccess = false;
        }
        this.setState({pageAccess});
    }

    componentWillUnmount(){
        // this.props.resetSetWithdrawalLimit();
    }

    render() { 

        return (
            <div className="p-8 pb-14 sm:p-14 md:pt-20">
                <div className="lg:pl-4 lg:pr-4">

                    {(this.state.pageAccess === false) &&
                        <div className="w-96 mx-auto md:py-24 md:mt-6">
                            <div className="table-info">
                                <FontAwesomeIcon icon="exclamation-circle" className="text-red-700" style={{"fontSize":"4.5rem"}} />
                                <div className="mt-2 font-bold text-2xl">
                                    Link Broken
                                </div>
                                <div className="mt-1">
                                    Sorry, your set-withdrawal-limit link is broken.&nbsp;
                                    <br className="hidden md:block" />
                                    Please contact us if you feel this error is from us.
                                </div>
                                <div className="mt-4 space-y-2">
                                    <button type="button" onClick={() => window.location.reload(false)} className="btn btn-block btn-lg btn-ep-primary mx-auto">
                                        Retry
                                    </button>
                                    {/* 
                                    <button type="button" onClick={this.toggleChatWidget} className="btn btn-block btn-lg btn-transparent-black mx-auto">
                                        Contact Us
                                    </button>
                                     */}
                                </div>
                            </div>
                        </div>
                    }

                    {(this.state.pageAccess === true) &&
                        <>

                            {(this.props.setWithdrawalLimitLoading === true) &&
                                <div className="w-96 mx-auto md:py-24 md:mt-6">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="circle-notch" spin style={{"fontSize":"4.5rem"}} />
                                        <div className="mt-2 font-bold text-2xl">
                                            Setting withdrawal limit...
                                        </div>
                                        <div className="hidden mt-2">
                                            Please wait while we set the withdrawal limit on your account to <b>75%</b>.
                                        </div>
                                    </div>
                                </div>
                            }

                            {(this.props.setWithdrawalLimitLoading === false) && (this.props.setWithdrawalLimitSuccess === false) &&
                                <div className="w-96 mx-auto md:py-24 md:mt-6">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="exclamation-circle" className="text-red-700" style={{"fontSize":"4.5rem"}} />
                                        <div className="mt-2 font-bold text-2xl">
                                            Update failed
                                        </div>
                                        <div className="mt-1">
                                            Sorry, the 75% withdrawal limit could not be set on your account.&nbsp;
                                            <br className="hidden md:block" />
                                            Please contact us if you feel this error is from us.
                                        </div>
                                        <div className="mt-4 space-y-2">
                                            <button type="button" onClick={() => window.location.reload(false)} className="btn btn-block btn-lg btn-ep-primary mx-auto">
                                                Retry
                                            </button>
                                            {/* 
                                            <button type="button" onClick={this.toggleChatWidget} className="btn btn-block btn-lg btn-transparent-black mx-auto">
                                                Contact Us
                                            </button>
                                             */}
                                        </div>
                                    </div>
                                </div>
                            }

                            {(this.props.setWithdrawalLimitLoading === false) && (this.props.setWithdrawalLimitSuccess === true) &&
                                <div className="mt-8 mx-auto lg:mx-0 text-center max-w-md">
                                    <div className="h-48 sm:h-56">
                                        <img src={thankYouIcon} alt="EarniPay" className="h-full object-contain mx-auto" />
                                    </div>
                                    <div className="mt-8 font-boing font-semibold text-2xl sm:text-3xl">
                                        75% activated
                                    </div>
                                    <div className="mt-4 text-gray-500">
                                        A 75% withdrawal limit has been applied to your company account.
                                        <br className="hidden md:block" />
                                        Thank you.
                                    </div>
                                    <Link to="/" className="btn btn-lg btn-block btn-ep-primary mt-8">Dismiss</Link>
                                </div>
                            }
                        </>
                    }

                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    setWithdrawalLimitLoading: state.entities.general.setWithdrawalLimitLoading,
    setWithdrawalLimitSuccess: state.entities.general.setWithdrawalLimitSuccess,
});

const mapDispatchToProps = (dispatch) => ({
    setWithdrawalLimit: (params) => dispatch(general.setWithdrawalLimit(params)),
    // resetSetWithdrawalLimit: () => dispatch(general.resetSetWithdrawalLimit()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStartedSuccess);